import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInbox } from "@fortawesome/free-solid-svg-icons";

import { IconComponent } from "./types";

export const InboxIcon: IconComponent = (props) => {
  return <FontAwesomeIcon {...props} icon={faInbox} color="#53ACF2" />;
};
